<div class="fullwidth-layout-container" basepage="secondary">
  <div class="row">
    <div class="col">
      <div class="page-nav-header no-pills">
        <div class="back-container" style="display: flex">
          <button type="button" class="btn btn-transparent p-0" (click)="goBack()" aria-label="back">
            <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">back</span>
          </button>
          <fui-heading [text]="'Post by ' + (post ? post.author.name : '...')" [level]="2" fontSize="f9"></fui-heading>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row learn-content-details">
      <div class="col">
        @if (post) {
          <div class="m-t-50">
            <myp-comment [betaStringId]="betaStringId" [comment]="post" [isCommunityPost]="true" [replies]="replies"></myp-comment>
          </div>
        }
        @if (postNotFound) {
          <div class="m-t-50 text-center">
            <div><fa-icon icon="times-circle" class="t-30 c-red"></fa-icon></div>
            <div class="m-t-20 t-16 text-muted">This post is no longer available (or never existed).</div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
